import { render, staticRenderFns } from "./itemBlock.vue?vue&type=template&id=51ae2d24&scoped=true"
import script from "./itemBlock.vue?vue&type=script&lang=js"
export * from "./itemBlock.vue?vue&type=script&lang=js"
import style0 from "./itemBlock.vue?vue&type=style&index=0&id=51ae2d24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ae2d24",
  null
  
)

export default component.exports